<template>
  <div class="wang-editor-wrap">
    <Toolbar
      class="wang-editor-toolbar"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      class="wang-editor-body"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
    <div v-show="uploading" ref="uploadMask" class="w-e-upload-mask">
      <div class="w-e-upload-panel">
        <i class="el-icon-loading"></i>
        <p v-if="uploadTotal <= 1">正在上传 {{ uploadPercent }}%</p>
        <p v-else>上传成功 {{ uploadSuccess }}/{{ uploadTotal }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
import { createEditorConfig, registerVideoHtml, registerMediaPastePlugin, bindEditorVm } from "./editor";

registerVideoHtml();
registerMediaPastePlugin();

export default {
  name: "RichTextarea",

  components: {
    Editor,
    Toolbar
  },

  model: {
    prop: "value",
    event: "input"
  },

  props: {
    value: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      editor: null,
      html: this.value || "",
      mode: "default",
      toolbarConfig: {},
      editorConfig: createEditorConfig(this),
      uploading: false,
      uploadTotal: 0,
      uploadPending: 0,
      uploadSuccess: 0,
      uploadPercent: 0,
      hideUploadTimer: null
    };
  },

  watch: {
    value(val) {
      const next = val || "";
      if (next === this.html) {
        return;
      }
      this.html = next;
      if (this.editor && this.editor.getHtml() !== next) {
        this.editor.setHtml(next);
      }
    },
    html(val) {
      if (val !== this.value) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },

  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
      bindEditorVm(this.editor, this);
      if (this.value && editor.getHtml() !== this.value) {
        editor.setHtml(this.value);
      }
    },
    beginMediaUpload(count) {
      const n = count > 0 ? count : 1;
      if (this.hideUploadTimer) {
        clearTimeout(this.hideUploadTimer);
        this.hideUploadTimer = null;
      }
      this.uploadTotal += n;
      this.uploadPending += n;
      this.uploading = true;
      if (this.uploadTotal <= 1) {
        this.uploadPercent = 0;
      }
    },
    setMediaUploadPercent(percent) {
      if (this.uploadTotal <= 1) {
        const value = Number(percent) || 0;
        this.uploadPercent = Math.max(0, Math.min(99, value));
      }
    },
    finishMediaUpload(success) {
      this.uploadPending = Math.max(0, this.uploadPending - 1);
      if (success) {
        this.uploadSuccess += 1;
        if (this.uploadTotal <= 1) {
          this.uploadPercent = 100;
        }
      }
      if (this.uploadPending === 0) {
        this.hideUploadTimer = setTimeout(() => {
          this.uploading = false;
          this.uploadTotal = 0;
          this.uploadPending = 0;
          this.uploadSuccess = 0;
          this.uploadPercent = 0;
          this.hideUploadTimer = null;
        }, 400);
      }
    },
    mountUploadMask() {
      const mask = this.$refs.uploadMask;
      if (mask && mask.parentNode !== document.body) {
        document.body.appendChild(mask);
      }
    }
  },

  mounted() {
    this.mountUploadMask();
  },

  beforeDestroy() {
    if (this.hideUploadTimer) {
      clearTimeout(this.hideUploadTimer);
      this.hideUploadTimer = null;
    }
    const mask = this.$refs.uploadMask;
    if (mask && mask.parentNode) {
      mask.parentNode.removeChild(mask);
    }
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  }
};
</script>

<style lang="less">
.wang-editor-wrap {
  z-index: 1;
  width: 100%;
  overflow: visible;
  background: #fff;
  border: 1px solid #ccc;

  .wang-editor-toolbar {
    border-bottom: 1px solid #ccc;
  }

  .wang-editor-body {
    min-height: 300px;
    height: 350px;
    overflow-y: hidden;
  }

  &.wang-editor-style {
    display: flex;
    flex-direction: column;
    min-height: 400px;

    .wang-editor-body {
      flex: 1;
      height: auto;
      min-height: 300px;
    }
  }

  .w-e-text-container {
    background: #fff;
  }

  .w-e-textarea-video-container {
    width: 100%;

    video {
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;
      background: #000;
    }
  }
}

.w-e-full-screen-container {
  z-index: 4000;
}

.w-e-bar-item-menus-container,
.w-e-select-list,
.w-e-drop-panel,
.w-e-modal {
  z-index: 4100 !important;
}

.w-e-upload-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
}

.w-e-upload-panel {
  min-width: 180px;
  padding: 24px 32px;
  color: #fff;
  text-align: center;
  pointer-events: none;

  .el-icon-loading {
    font-size: 32px;
  }

  p {
    margin: 12px 0 0;
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
